// extracted by mini-css-extract-plugin
module.exports = {"container":"SaleBar_container__2it6c","favoritesTab":"SaleBar_favoritesTab__1N8k7","button":"SaleBar_button__1Ex7D"};